// src/pages/NotAllowPage/NotAllowPage.jsx
import React, { useMemo } from "react";
import { Button, Card } from "antd";
import { useNavigate } from "react-router-dom";

import not_allow from "../../assets/user-not-allow/user_not_allow.png";
import ResponseMessage from "../../components/Comman/Notification/ResponseMessge";

const NotAllowPage = () => {
  const navigate = useNavigate();

  // ✅ read unit info from localStorage
  const unitName = localStorage.getItem("unit_name") || "Unknown Unit";
  const unitCode = localStorage.getItem("unit_code") || "";
  const reason = localStorage.getItem("nav_message") || ""; // ✅ ONLY reason line (no duplicates)

  // ✅ read dept ids from stored userData
  const deptIds = useMemo(() => {
    try {
      const raw = localStorage.getItem("userData");
      if (!raw) return "Unknown";
      const parsed = JSON.parse(raw);
      const u = parsed?.data || parsed; // supports both shapes
      return u?.dept_ids || u?.dept || "Unknown";
    } catch (e) {
      return "Unknown";
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("unit_code");
    localStorage.removeItem("unit_name");
    localStorage.removeItem("nav_message");

    navigate("/login", { replace: true });

    try {
      ResponseMessage.success("Logout Successful.");
    } catch (e) {
      console.log(e);
    }
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
    padding: 16,
  };

  const cardStyle = {
    width: 420,
    textAlign: "center",
    boxShadow: "0 10px 24px rgba(0,0,0,0.15)",
    borderRadius: 14,
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    marginBottom: 14,
    borderRadius: 12,
  };

  const blockStyle = {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    padding: 14,
    marginTop: 10,
    textAlign: "left",
  };

  const lineStyle = {
    margin: "6px 0",
    color: "#475569",
    fontSize: 13,
    lineHeight: 1.6,
  };

  return (
    <div style={containerStyle}>
      <Card style={cardStyle} hoverable>
        <img src={not_allow} alt="Not Allowed" style={imageStyle} />

        <div style={{ padding: "4px 16px 16px" }}>
          <h2 style={{ marginBottom: 6 }}>Access Denied</h2>

          <div style={blockStyle}>
            <div style={lineStyle}>
              <b>Unit:</b> {unitName} {unitCode ? `(${unitCode})` : ""}
            </div>

            <div style={lineStyle}>
              <b>Department ID(s):</b> {deptIds}
            </div>

            <div style={{ ...lineStyle, marginTop: 10 }}>
              This department does not have access to any modules.
              <br />
              Please contact admin to enable permissions.
            </div>

            {reason ? (
              <div style={{ ...lineStyle, marginTop: 10, color: "#64748b" }}>
                {reason}
              </div>
            ) : null}
          </div>

          <Button
            type="primary"
            onClick={handleLogout}
            style={{ marginTop: 14, width: "100%", height: 44, borderRadius: 10 }}
          >
            Go Back to Login
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default NotAllowPage;